import { render, staticRenderFns } from "./PermissionControl.vue?vue&type=template&id=7e4e0446&scoped=true&"
import script from "./PermissionControl.vue?vue&type=script&lang=js&"
export * from "./PermissionControl.vue?vue&type=script&lang=js&"
import style0 from "./PermissionControl.vue?vue&type=style&index=0&id=7e4e0446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4e0446",
  null
  
)

export default component.exports